import React, { FC, useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useOrganizations } from '../context/OrganizationsContext'
import ApplicationsContextProvider from '../context/ApplicationsContext'
import ErrorHandlingInterceptor from '../components/error-handling/ErrorHandlingInterceptor'
import { useAuth } from '../contexts/AuthContext'

const PrivateRoute: FC<{ children?: any }> = ({ children }) => {
  const { org } = useParams()
  const navigate = useNavigate()
  const { organizations, isLoadingOrganizations } = useOrganizations()
  const { isLoggedIn } = useAuth()

  useEffect(() => {
    if (isLoadingOrganizations) {
      return
    }

    if (organizations.length === 0) {
      navigate('/not-authorized')
      return
    }

    if (!org) {
      navigate(`/${organizations.at(0)?.organizationCode}`)
      return
    }

    const foundOrg = organizations.find((organization) => organization.organizationCode == org)

    if (foundOrg) {
      return
    }

    navigate('/not-authorized')
  }, [organizations, org, navigate, isLoadingOrganizations])

  return isLoggedIn ? (
    <ErrorHandlingInterceptor>
      <ApplicationsContextProvider>{children}</ApplicationsContextProvider>
    </ErrorHandlingInterceptor>
  ) : (
    <Outlet />
  )
}

export default PrivateRoute
